// @flow
import { createSelector } from 'reselect';
import map from 'ramda/es/map';
import path from 'ramda/es/path';
import pipe from 'ramda/es/pipe';
import sortBy from 'ramda/es/sortBy';
import prop from 'ramda/es/prop';


type Images = Array<{
  thumb: string,
  standart: string,
  high: string,
  position: number,
}>

type ApiCategory = {
  position: number,
  ancestry: mixed, // ?
  slug: string,
  name: string,
  description: string,
  meta_title: string,
  meta_description: string,
  meta_keywords: mixed, // ?
  images: Images
}

// $FlowFixMe
const selectCategories = createSelector(
  state => state.shop.catalog.categories.children,
  pipe(
    map(({
      position,
      // ancestry,
      slug,
      name,
      // description,
      // meta_title,
      // meta_description,
      // meta_keywords,
      // children,
      images,
    }: ApiCategory) => ({
      slug,
      title: name,
      position,
      imgSrc: path([0, 'standart'], images),
    })),
    sortBy(prop('position')),
  ),
);

export default selectCategories;
